import { createSelector, createSlice, current } from '@reduxjs/toolkit';
import {
  RETAIL_AUTOMATION_TAB_ROUTE,
  RETAIL_AUTOMATION_TAB_ROUTE_V2,
} from '../../../constants/routePathConstants';
import { matchPath } from 'react-router-dom';
import { RETAIL_AUTOMATION_STEPS } from '../../../constants/retailAutomationConstants';
import { emptyRowData } from '../../../components/RetailAutomation/common/moduleHelper';
import { duplicateRemoveArrayObj } from '../../../helpers/jsHelper';
import { LogConsole } from '../../../helpers/logEvents';

export const TAB = {
  AUTOMATION: 'automation',
  STYLE: 'style',
};

export const initialSetSteps = () => {
  return [
    {
      label: 'Select Retail Store',
      value: RETAIL_AUTOMATION_STEPS.TEMPLATE,
      selected: true,
      completed: false,
      active: true,
      disabled: false,
      subLevels: [],
    },
    // {
    //   label: 'Select hotspot',
    //   value: RETAIL_AUTOMATION_STEPS.HOTSPOT,
    //   selected: false,
    //   addMore: true,
    //   active: false,
    //   disabled: false,
    //   subLevels: [
    //     {
    //       label: 'Camera Angle',
    //       value: RETAIL_AUTOMATION_STEPS.CAMERA,
    //       selected: false,
    //       completed: false,
    //     },
    //     {
    //       label: 'Product',
    //       value: RETAIL_AUTOMATION_STEPS.PRODUCT,
    //       selected: false,
    //       completed: false,
    //     },
    //     {
    //       label: 'Artwork',
    //       value: RETAIL_AUTOMATION_STEPS.ARTWORK,
    //       selected: false,
    //       completed: false,
    //     },
    //   ],
    // },
  ];
};

export const getInitialSets = (name) => {
  const setArr = [
    {
      id: 1,
      name: name,
      selected: true,
      showMenu: false,
      setSteps: initialSetSteps(),
    },
  ];
  return setArr;
};

const getInitialState = () => ({
  show: false,
  initialLoading: true,
  mainLoading: false,
  data: null,
  activeTab: TAB.AUTOMATION,
  // sets: getInitialSets('Set 1'),
  sets: [],
  selectedTemplate: null,
  enableProceed: false,
  enableBack: false,
  selectedSet: null,
  selectDeselectOption: null,
  selectedHotspots: null,
  selectedCameras: null,
  nameEditing: false,
  allTemplates: [],
  templateApiData: null,
  fullScreenLoader: false,
  artworkDefaultCombinations: {
    item: [],
  },
  artworkFinalCombinations: null,
  cardIndexClicked: null,
  propDataReceivedFromUnity: [],
  currentArtWorkCombinations: null,
  combinationLoaded: false,
  artworkDataAfterRender: null,
  resetArtworkData: null,
  enableStyleSection: false,
  combinationSectionLoader: false,
  currentSelectedTexture: null,
  switchToMaterial: false,
  onlyUnityLoader: false,
  selectedVariationProd: null,
  materialDuplicateData: null,
  artworkCardClicked: false,
  clickedUnityObjectPartInfo: null,
  productAdded: false,
  resetCombinationData: false,
  hotspotSwitched: false,
  replacePropResponseRecieved: null,
  textureCreatedAfterReplace: null,
  tempHotSpotProductsList: [],
  hotSpotProducts: {},
  templateId: null,
  combinationTextureMergedData: null,
  textureDataAfterBreak: null,
  defaultTextureData: {},
  currentSelectedProduct: null,
  rackNameEditing: {},
  combinationNameEditing: {},
  showGizmoMenu: false,
  showAddProp: false,
  productSavedToLibrary: false,
  duplicateProductProcess: false,
  clickedAddToCustomization: null,
  displayCompleteShelf: false,
  clearShelfData: false,
  fillTrayData: null,
  deleteTextureCard: false,
  allVariantsData: {},
  allCameras: [],
  selectedShelf: null,
  showTriangleLoader: false,
  loadingMessage: null,
  keepUnityAlive: false,
  artworkCameraRedux: null,
  isClearRackTriggered: null,
  openSaveTemplateModal: null,
  hotspotsJson: {}, // { [hotspotId]: {...json data}} }
  artworksJson: {}, // { [artworkId]: {...json data}} }
  variationProducts: [],
  selectedVariationId: null,
  currentHotSpotProductsList: [],
  rackShelfCount: 0,
});

const retailAutomation = createSlice({
  name: 'retailAutomation',
  initialState: getInitialState(),
  reducers: {
    resetState: () => {
      return getInitialState();
    },
    setShow: (state, { payload }) => {
      state.show = payload;
    },
    setInitialLoading: (state, { payload }) => {
      state.initialLoading = payload;
    },
    setMainLoading: (state, { payload }) => {
      state.mainLoading = payload;
    },
    setData: (state, { payload }) => {
      state.data = payload;
    },
    setActiveTab: (state, { payload }) => {
      state.activeTab = payload;
    },
    setAutomationSets: (state, { payload }) => {
      state.sets = payload;
    },
    setSelectedSet: (state, { payload }) => {
      state.selectedSet = payload;
    },
    setSelectedTemplate: (state, { payload }) => {
      state.selectedTemplate = payload;
    },
    setEnableProceed: (state, { payload }) => {
      state.enableProceed = payload;
    },
    setEnableBack: (state, { payload }) => {
      state.enableBack = payload;
    },
    setSelectDeselectOption: (state, { payload }) => {
      state.selectDeselectOption = payload;
    },
    setSelectedHotspots: (state, { payload }) => {
      state.selectedHotspots = payload;
    },
    setNameEditing: (state, { payload }) => {
      state.nameEditing = payload;
    },
    setAllTemplates: (state, { payload }) => {
      state.allTemplates = payload;
    },
    setTemplateApiData: (state, { payload }) => {
      state.templateApiData = payload;
    },
    setFullScreenLoader: (state, { payload }) => {
      state.fullScreenLoader = payload;
    },
    setArtworkDefaultCombinations: (state, { payload }) => {
      if (!Array.isArray(payload)) return;

      payload.forEach((material) => {
        const index = state.artworkDefaultCombinations?.item?.findIndex(
          (a) => a?.materialName === material?.materialName
        );

        if (index !== -1 && state?.artworkDefaultCombinations?.item) {
          // Update existing item
          state.artworkDefaultCombinations.item[index] = {
            ...state.artworkDefaultCombinations.item[index],
            extraData: {
              ...material,
              id: material.materialName,
              name: material.diffuseName || material.colorValue,
              thumbnail: material.diffuseImage,
            },
          };
        }
      });

      state.artworkDefaultCombinations.item = duplicateRemoveArrayObj(
        state.artworkDefaultCombinations.item,
        'id'
      );

      LogConsole('DEBUG___ARTWORK', {
        payload,
        current: current(state.artworkDefaultCombinations),
      });
    },

    // setArtworkDefaultCombinations: (state, { payload }) => {
    //   const index = state.artworkDefaultCombinations?.item?.findIndex(
    //     (a) => a?.materialName === payload?.materialName
    //   );

    //   if (index !== -1 && state?.artworkDefaultCombinations?.item) {
    //     // Update existing item
    //     state.artworkDefaultCombinations.item[index] = {
    //       ...state.artworkDefaultCombinations.item[index],
    //       extraData: {
    //         ...payload,
    //         id: payload.materialName,
    //         name: payload.diffuseName || payload.colorValue,
    //         thumbnail: payload.diffuseImage,
    //       },
    //     };
    //   }

    //   // state.artworkFinalCombinations = emptyRowData(state.artworkDefaultCombinations);
    // },
    setArtworkDefaultCombinationsThumbnail: (state, { payload }) => {
      const arr = [];
      for (let i = 0; i < state.artworkDefaultCombinations?.item?.length; i++) {
        if (
          state.artworkDefaultCombinations?.item?.[i]?.extraData?.objectName ===
          payload?.materialObjectName
        ) {
          arr.push(i);
        }
      }
      for (let i = 0; i < arr.length; i++) {
        state.artworkDefaultCombinations.item[arr[i]] = {
          ...state.artworkDefaultCombinations.item[arr[i]],
          thumbnail: payload.thumbnail,
          textureName: payload.textureName,
        };
      }

      state.artworkDefaultCombinations.item = duplicateRemoveArrayObj(
        state.artworkDefaultCombinations.item,
        'id'
      );

      // const index = state.artworkDefaultCombinations?.item?.findIndex(
      //   (a) => a?.extraData?.objectName === payload?.materialObjectName
      // );
      // if (index !== -1 && state?.artworkDefaultCombinations?.item?.[index]) {
      //   state.artworkDefaultCombinations.item[index] = {
      //     ...state.artworkDefaultCombinations.item[index],
      //     thumbnail: payload.thumbnail,
      //   };
      // }
    },
    setArtworkFinalCombinations: (state, { payload }) => {
      state.artworkFinalCombinations = payload;
    },
    setCardIndexClicked: (state, { payload }) => {
      // Added below condition to persist `seq_no` which we have added in uploadArtwork
      if (!payload) {
        state.cardIndexClicked = payload;
      } else {
        state.cardIndexClicked = { ...state.cardIndexClicked , ...payload };
      }
    },
    setPropDataReceivedFromUnity: (state, { payload }) => {
      const index = state.propDataReceivedFromUnity.findIndex(
        (a) => a.objectName === payload.objectName
      );

      if (index !== -1) {
        // Update existing item
        state.propDataReceivedFromUnity[index] = {
          ...state.propDataReceivedFromUnity[index],
          ...payload,
        };
      } else {
        // Add new item
        state.propDataReceivedFromUnity?.push({
          ...payload,
          objectId: +payload.objectId,
          objectName: payload.objectName,
          rackShelfCount: +payload?.rackShelfCount,
        });
      }

      if (payload?.materialName?.length > 0) {
        payload?.materialName?.forEach((material) => {
          state.artworkDefaultCombinations?.item?.push({
            id: material,
            variationObjectId: +payload.objectId,
            variationObjectName: payload.objectName,
            materialName: material,
            isGroupProp: payload.isGroupProp,
            groupPropParentObjectName: payload.groupPropParentObjectName,
            groupPropId: parseInt(payload.groupPropId),
          });
        });

        state.artworkDefaultCombinations.item = duplicateRemoveArrayObj(
          state.artworkDefaultCombinations.item,
          'id'
        );
      }
    },
    setCurrentArtWorkCombinations: (state, { payload }) => {
      state.currentArtWorkCombinations = payload;
    },
    resetArtworkStates: (state, { payload }) => {
      state.artworkFinalCombinations = null;
      if (!payload) {
        state.propDataReceivedFromUnity = [];
        state.artworkDefaultCombinations = { item: [] };
      }
      state.currentArtWorkCombinations = null;
      state.combinationLoaded = false;
      state.combinationTextureMergedData = null;
    },
    setCombinationLoaded: (state, { payload }) => {
      state.combinationLoaded = payload;
    },
    setArtworkDataAfterRender: (state, { payload }) => {
      state.artworkDataAfterRender = payload;
    },
    setResetArtworkData: (state, { payload }) => {
      state.resetArtworkData = payload;
    },
    setEnableStyleSection: (state, { payload }) => {
      state.enableStyleSection = payload;
    },
    setCombinationSectionLoader: (state, { payload }) => {
      state.combinationSectionLoader = payload;
    },
    setCurrentSelectedTexture: (state, { payload }) => {
      state.currentSelectedTexture = payload;
    },
    setSwitchToMaterial: (state, { payload }) => {
      state.switchToMaterial = payload;
    },
    setOnlyUnityLoader: (state, { payload }) => {
      state.onlyUnityLoader = payload;
    },
    setSelectedVariationProd: (state, { payload }) => {
      state.selectedVariationProd = payload;
    },
    setMaterialDuplicateData: (state, { payload }) => {
      state.materialDuplicateData = payload;
    },
    setArtworkCardClicked: (state, { payload }) => {
      state.artworkCardClicked = payload;
    },
    setClickedUnityObjectPartInfo: (state, { payload }) => {
      state.clickedUnityObjectPartInfo = payload;
    },
    setProductAdded: (state, { payload }) => {
      state.productAdded = payload;
    },
    setResetCombinationData: (state, { payload }) => {
      state.resetCombinationData = payload;
    },
    setHotspotSwitched: (state, { payload }) => {
      state.hotspotSwitched = payload;
    },
    setReplacePropResponseRecieved: (state, { payload }) => {
      state.replacePropResponseRecieved = payload;
    },
    updateOnlyDefaultArtwork: (state, { payload }) => {
      state.artworkDefaultCombinations = payload;
    },
    updateOnlyPropDataFromUnity: (state, { payload }) => {
      state.propDataReceivedFromUnity = payload;
    },
    setTextureCreatedAfterReplace: (state, { payload }) => {
      state.textureCreatedAfterReplace = payload;
    },
    setTemplateId: (state, { payload }) => {
      state.templateId = payload;
    },
    setTempHotSpotProductsList: (state, { payload }) => {
      state.tempHotSpotProductsList = payload;
    },
    setCurrentHotSpotProductsList: (state, { payload }) => {
      state.currentHotSpotProductsList = payload;
    },
    setHotSpotProducts: (state, { payload }) => {
      if (payload?.length) {
        state.hotSpotProducts = payload?.reduce((a, c) => {
          if (c?.products?.length) return { ...a, [c?.id]: c?.products };
          else return a;
        }, state.hotSpotProducts);

        LogConsole('DEBUG___state.hotSpotProducts', payload, state.hotSpotProducts);
      }
    },
    updateHotSpotProducts: (state, { payload }) => {
      state.hotSpotProducts = payload;
    },
    setCombinationTextureMergedData: (state, { payload }) => {
      state.combinationTextureMergedData = payload;
    },
    setTextureDataAfterBreak: (state, { payload }) => {
      state.textureDataAfterBreak = payload;
    },
    setDefaultTextureData: (state, { payload }) => {
      const { textureName } = payload;
      state.defaultTextureData[textureName] = payload;
    },
    setCurrentSelectedProduct: (state, { payload }) => {
      state.currentSelectedProduct = payload;
    },
    setRackNameEditing: (state, { payload }) => {
      const { id, flag, hotspotId, value } = payload;
      if (!id || !hotspotId) {
        return;
      }
      if (!state.rackNameEditing?.[hotspotId]) {
        state.rackNameEditing[hotspotId] = {};
      }
      if (!state.rackNameEditing?.[hotspotId]?.[id]) {
        state.rackNameEditing[hotspotId][id] = {};
      }
      state.rackNameEditing[hotspotId][id].flag = flag;
      if (value) state.rackNameEditing[hotspotId][id].name = value;
    },
    setCombinationNameEditing: (state, { payload }) => {
      const { id, flag, hotspotId, value } = payload;
      if (!id || !hotspotId) {
        return;
      }
      if (!state.combinationNameEditing?.[hotspotId]) {
        state.combinationNameEditing[hotspotId] = {};
      }
      if (!state.combinationNameEditing?.[hotspotId]?.[id]) {
        state.combinationNameEditing[hotspotId][id] = {};
      }
      state.combinationNameEditing[hotspotId][id].flag = flag;
      if (value) state.combinationNameEditing[hotspotId][id].name = value;
    },
    setShowGizmoMenu: (state, { payload }) => {
      state.showGizmoMenu = payload;
    },
    setShowAddProp: (state, { payload }) => {
      state.showAddProp = payload;
    },
    setProductSavedToLibrary: (state, { payload }) => {
      state.productSavedToLibrary = payload;
    },
    setDuplicateProductProcess: (state, { payload }) => {
      state.duplicateProductProcess = payload;
    },
    setClickedAddToCustomization: (state, { payload }) => {
      state.clickedAddToCustomization = payload;
    },
    setDisplayCompleteShelf: (state, { payload }) => {
      state.displayCompleteShelf = payload;
    },
    setClearShelfData: (state, { payload }) => {
      state.clearShelfData = payload;
    },
    setFillTrayData: (state, { payload }) => {
      state.fillTrayData = payload;
    },
    setDeleteTextureCard: (state, { payload }) => {
      state.deleteTextureCard = payload;
    },
    setAllVariantsData: (state, { payload }) => {
      state.allVariantsData = payload;
    },
    setAllCameras: (state, { payload }) => {
      state.allCameras = payload;
    },
    setSelectedShelf: (state, { payload }) => {
      state.selectedShelf = payload;
    },
    setShowTriangleLoader: (state, { payload }) => {
      state.showTriangleLoader = payload;
    },
    setShowLoadingMessage: (state, { payload }) => {
      state.loadingMessage = payload;
    },
    setKeepUnityAlive: (state, { payload }) => {
      state.keepUnityAlive = payload;
    },
    setArtworkCameraRedux: (state, { payload }) => {
      state.artworkCameraRedux = payload;
    },
    setIsClearRackTriggered: (state, { payload }) => {
      state.isClearRackTriggered = payload;
    },
    setOpenSaveTemplateModal: (state, { payload }) => {
      state.openSaveTemplateModal = payload;
    },
    setHotspotJson: (state, { payload }) => {
      if (!payload.id || !payload.json) return;
      state.hotspotsJson[payload.id] = payload.json;
    },
    setArtworkJson: (state, { payload }) => {
      if (!payload.id || !payload.json) return;
      state.artworksJson[payload.id] = payload.json;
    },
    setVariationProducts: (state, { payload }) => {
      state.variationProducts = payload;
    },
    setSelectedVariationId: (state, { payload }) => {
      state.selectedVariationId = payload;
    },
    setRackShelfCount: (state, { payload }) => {
      state.rackShelfCount = payload;
    },
  },
});

export const retailAutomationActions = retailAutomation.actions;
export const retailAutomationReducer = retailAutomation.reducer;
export default retailAutomationReducer;

const createPathnameSelector = (...args) => createSelector(() => window.location.pathname, ...args);
export const selectSidebarTab = createPathnameSelector((pathname) => {
  // RETAIL_AUTOMATION_TAB_ROUTE
  const match = matchPath({ path: RETAIL_AUTOMATION_TAB_ROUTE_V2 + '/*' }, pathname);
  return match?.params?.tabName || TAB.AUTOMATION;
});

export const selectShowAddProp = (state) => state.retailAutomation.showAddProp;
export const selectCombinationNameEditing = (state) =>
  state.retailAutomation.combinationNameEditing;
export const selectCombinationEditing = (id) => (state) => {
  return state.combinationNameEditing?.[id]?.flag;
};
export const selectRackEditing = (id) => (state) => {
  return state.rackNameEditing?.[id]?.flag;
};
export const selectRackNameEditing = (state) => state.retailAutomation.rackNameEditing;
export const selectDefaultTextureData = (state) => state.retailAutomation.defaultTextureData;
export const selectInitialLoading = (state) => state.retailAutomation.initialLoading;
export const selectMainLoading = (state) => state.retailAutomation.mainLoading;

export const selectActiveTab = (state) => state.retailAutomation.activeTab;
export const selectAutomationSets = (state) => state.retailAutomation.sets;
export const selectSelectedTemplates = (state) => state.retailAutomation.selectedTemplate;
export const selectEnableProceed = (state) => state.retailAutomation.enableProceed;
export const selectEnableBack = (state) => state.retailAutomation.enableBack;
export const selectSelectedSet = (state) => state.retailAutomation.selectedSet;
export const selectSelectDeselectOption = (state) => state.retailAutomation.selectDeselectOption;
export const selectSelectedHotspots = (state) => state.retailAutomation.selectedHotspots;

export const selectNameEditing = (state) => state.retailAutomation.nameEditing;
export const selectRetailAutomationName = (state) => state.retailAutomation?.data?.name;
export const selectRetailAutomationId = (state) => state.retailAutomation.data?.id;
export const selectRetailAutomationData = (state) => state.retailAutomation.data;
export const selectAllTemplates = (state) => state.retailAutomation.allTemplates;
export const selectNoStoreTemplatesAreAssigned = (state) =>
  state.retailAutomation.allTemplates?.length === 0;
export const selectTemplateApiData = (state) => state.retailAutomation.templateApiData;
export const selectFullScreenLoader = (state) => state.retailAutomation.fullScreenLoader;

export const selectActiveSetDetails = (state) => {
  const sets = selectAutomationSets(state);
  const activeSet = sets?.find((a) => a.selected === true);
  const activeAutomationId = activeSet?.retail_automation;
  const activeTemplateId = activeSet?.template;
  const activeHotspot = activeSet?.setSteps?.[0]?.subLevels.find(
    (data) => data.active && data.is_enable
  );
  const activeLinkedPropObjectId = parseInt(activeHotspot?.json_data?.linked_prop_object_id);
  const activeLinkedPropObjectName = activeHotspot?.json_data?.linked_prop_object_name;

  return {
    activeSet,
    activeAutomationId,
    activeTemplateId,
    activeHotspot,
    activeLinkedPropObjectId,
    activeLinkedPropObjectName,
  };
};

export const selectArtworkDefaultCombinations = (state) =>
  state.retailAutomation.artworkDefaultCombinations;
export const selectArtworkFinalCombinations = (state) =>
  state.retailAutomation.artworkFinalCombinations;
export const selectCardIndexClicked = (state) => state.retailAutomation.cardIndexClicked;

export const selectPropDataReceivedFromUnity = (state) =>
  state.retailAutomation.propDataReceivedFromUnity;

export const selectCurrentArtWorkCombinations = (state) =>
  state.retailAutomation.currentArtWorkCombinations;
export const selectCombinationLoaded = (state) => state.retailAutomation.combinationLoaded;
export const selectArtworkDataAfterRender = (state) =>
  state.retailAutomation.artworkDataAfterRender;
export const selectResetArtworkData = (state) => state.retailAutomation.resetArtworkData;
export const selectEnableStyleSection = (state) => state.retailAutomation.enableStyleSection;
export const selectCombinationSectionLoader = (state) =>
  state.retailAutomation.combinationSectionLoader;
export const selectCurrentSelectedTexture = (state) =>
  state.retailAutomation.currentSelectedTexture;
export const selectSwitchToMaterial = (state) => state.retailAutomation.switchToMaterial;
export const selectOnlyUnityLoader = (state) => state.retailAutomation.onlyUnityLoader;
export const selectSelectedVariationProd = (state) => state.retailAutomation.selectedVariationProd;
export const selectMaterialDuplicateData = (state) => state.retailAutomation.materialDuplicateData;
export const selectArtworkCardClicked = (state) => state.retailAutomation.artworkCardClicked;
export const selectUnityClickedObjectPartInfo = (state) =>
  state.retailAutomation.clickedUnityObjectPartInfo;
export const selectProductAdded = (state) => state.retailAutomation.productAdded;
export const selectResetCombinationData = (state) => state.retailAutomation.resetCombinationData;
export const selectHotspotSwitched = (state) => state.retailAutomation.hotspotSwitched;
export const selectReplacePropResponseRecieved = (state) =>
  state.retailAutomation.replacePropResponseRecieved;
export const selectTextureCreatedAfterReplace = (state) =>
  state.retailAutomation.textureCreatedAfterReplace;
export const selectTempHotSpotProductsList = (state) =>
  state.retailAutomation.tempHotSpotProductsList;
export const selectCurrentHotSpotProductsList = (state) =>
  state.retailAutomation.currentHotSpotProductsList;
export const selectHotSpotProducts = (state) => state.retailAutomation.hotSpotProducts;
export const selectTemplateId = (state) => state.retailAutomation.templateId;
export const selectCombinationTextureMergedData = (state) =>
  state.retailAutomation.combinationTextureMergedData;
export const selectTextureDataAfterBreak = (state) => state.retailAutomation.textureDataAfterBreak;
export const selectCurrentSelectedProduct = (state) =>
  state.retailAutomation.currentSelectedProduct;
export const selectShowGizmoMenu = (state) => state.retailAutomation.showGizmoMenu;
export const selectProductSavedToLibrary = (state) => state.retailAutomation.productSavedToLibrary;
export const selectDuplicateProductProcess = (state) =>
  state.retailAutomation.duplicateProductProcess;
export const selectClickedAddToCustomization = (state) =>
  state.retailAutomation.clickedAddToCustomization;
export const selectDisplayCompleteShelf = (state) => state.retailAutomation.displayCompleteShelf;
export const selectClearShelfData = (state) => state.retailAutomation.clearShelfData;
export const selectFillTrayData = (state) => state.retailAutomation.fillTrayData;
export const selectDeleteTextureCard = (state) => state.retailAutomation.deleteTextureCard;
export const selectAllVariantsData = (state) => state.retailAutomation.allVariantsData;
export const selectAllCameras = (state) => state.retailAutomation.allCameras;
export const selectSelectedShelf = (state) => state.retailAutomation.selectedShelf;
export const selectShowTriangleLoader = (state) => state.retailAutomation.showTriangleLoader;
export const selectLoadingMessage = (state) => state.retailAutomation.loadingMessage;
export const selectKeepUnityAlive = (state) => state.retailAutomation.keepUnityAlive;
export const selectArtworkCameraRedux = (state) => state.retailAutomation.artworkCameraRedux;
export const selectIsClearRackTriggered = (state) => state.retailAutomation.isClearRackTriggered;
export const selectOpenSaveTemplateModal = (state) => state.retailAutomation.openSaveTemplateModal;

export const selectHotspotsJson = (state) => state.retailAutomation.hotspotsJson;
export const selectArtworksJson = (state) => state.retailAutomation.artworksJson;
export const selectVariationProducts = (state) => state.retailAutomation.variationProducts;
export const selectSelectedVariationId = (state) => state.retailAutomation.selectedVariationId;
export const selectCurrentSelectedProductData = (state) => {
  const list = selectCurrentHotSpotProductsList(state);
  const variationId = selectSelectedVariationId(state);
  return list?.find((a) => parseInt(a.product) === variationId) || null;
};
export const selectRackShelfCount = (state) => state.retailAutomation.rackShelfCount;

